export const SERVICES = [
  {
    id: "bookkeeping",
    number: "01",
    title: "Bookkeeping & Accounting",
    subtitle: "Accurate Records",
    description:
      "Accurate financial records, timely reporting, and books you can trust.",
    icon: "BookOpen",
  },
  {
    id: "reporting",
    number: "02",
    title: "Financial Reporting",
    subtitle: "Monthly Clarity",
    description:
      "Clear monthly reports that help you understand performance and make informed decisions.",
    icon: "FileBarChart",
  },
  {
    id: "cashflow",
    number: "03",
    title: "Cash Flow Management",
    subtitle: "Liquidity & Planning",
    description:
      "Monitor cash, improve liquidity, and plan confidently for what’s ahead.",
    icon: "Waves",
  },
  {
    id: "cfo",
    number: "04",
    title: "Controller & Fractional CFO Services",
    subtitle: "Senior Financial Leadership",
    description:
      "Strategic financial leadership without the cost of a full-time executive.",
    icon: "Briefcase",
  },
  {
    id: "budgeting",
    number: "05",
    title: "Budgeting & Financial Forecasting",
    subtitle: "Plan for Growth",
    description:
      "Plan for growth with realistic budgets and forward-looking financial models.",
    icon: "Calculator",
  },
  {
    id: "fpa",
    number: "06",
    title: "Financial Planning & Analysis (FP&A)",
    subtitle: "Insight to Action",
    description: "Turn financial data into actionable business insights.",
    icon: "LineChart",
  },
  {
    id: "tax",
    number: "07",
    title: "Tax Coordination & Compliance",
    subtitle: "Year-Round Readiness",
    description:
      "Work seamlessly with your CPA and tax advisors while staying organized year-round.",
    icon: "ScrollText",
  },
  {
    id: "systems",
    number: "08",
    title: "Accounting Systems & Process Automation",
    subtitle: "Modern Finance Stack",
    description:
      "Implement efficient financial systems that save time and improve accuracy.",
    icon: "Settings2",
  },
  {
    id: "backoffice",
    number: "09",
    title: "Back-Office Operations",
    subtitle: "Admin & Controls",
    description:
      "Support for essential financial and administrative processes that keep your business running smoothly.",
    icon: "Building2",
  },
];

export const INDUSTRIES = [
  "Software & SaaS",
  "Fintech",
  "Healthtech",
  "E-commerce",
  "Consumer Brands",
  "Marketplaces",
  "Climate & Deep Tech",
  "Professional Services",
];

export const STATS = [
  { value: "120+", label: "Founders Supported" },
  { value: "$480M", label: "Capital Advised" },
  { value: "9", label: "Core Practice Areas" },
  { value: "24hr", label: "Response SLA" },
];
